module.exports = __webpack_public_path__ + "static/Beekman-icon-b903390f9c451a00559f4372f9485a34.jpg";